
import IntroBox from "../components/about_us/intro";
import Quotes from "../components/about_us/quotes";
import PrimaryButton from "../components/about_us/primary_button";
import SecIntroBox from "../components/about_us/secondary_intro";
import Number from "../components/about_us/number";
import ContactSection from "../components/about_us/get_in_touch";



const About = () => {
    return(<>
        <IntroBox/>
        <Quotes/>
        <PrimaryButton/>
        <SecIntroBox/>
        <Number/>
        <ContactSection/>
</> 
        
    )
}
export default About;